<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="资金余额表"
      :page="page"
      :show-query="true"
      :get-data-func="api.dayList"
      v-if="trendShow"
      :queryParamsAppend="{}"
      urlHash="finance/cashier/funddaily"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/bankCheckIn").default,
      trendShow: true,
      tableData: [],
    };
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/cashier/funddaily")) {
      const findIndex = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "InAmount"
      );
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
      const findIndex1 = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "OutAmount"
      );
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1);
      const findIndex2 = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "LeftAmount"
      );
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1);
    }
  },
  methods: {
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.getDayListExport(params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>
